module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedThin.34474ad.woff2";